module.exports = __webpack_public_path__ + "img/forecast.65137b1d.svg";